<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-form v-model="valid" @submit.prevent="create()">
          <v-text-field
            v-model="orderNumber"
            :value="orderNumber"
            outlined
            :rules="[v => !!v || 'Item is required']"
            required
            label="Bestellnummer"
          />
          <v-divider class="my-4" />
          <template v-for="(item, key) in toAdd">
            <v-autocomplete
              :key="key"
              v-model="item.purchaseItem"
              :items="availablePurchaseItems"
              item-text="name"
              return-object
              :rules="[v => !!v || 'Item is required']"
              required
              label="Einkaufsartikel"
            />
            <v-text-field
              :key="key"
              v-model="item.amount"
              :rules="[v => !!v || 'Item is required']"
              required
              label="Stückzahl"
              type="number"
            />
            <MoneyInputField
              :key="key"
              v-model="item.price"
              :rules="[v => !!v || 'Item is required']"
              required
              label="Stückpreis"
            />
            <div :key="key" class="d-flex justify-end">
              <v-checkbox v-model="item.closed" label="Lieferung Abgeschlossen" @click="updateDeliveryStatus(item.purchase_item_data_id, item.closed)" />
            </div>
            <div :key="key" class="d-flex justify-end">
              <v-btn color="primary" @click="remove(key)">
                <v-icon>
                  mdi-minus
                </v-icon>
              </v-btn>
            </div>
            <v-divider :key="key" class="my-4" />
          </template>
          <div class="d-flex justify-end ">
            <v-btn color="primary" @click="add">
              <v-icon>
                mdi-plus
              </v-icon>
            </v-btn>
          </div>
          <div class="d-flex justify-end mt-4">
            <v-btn :disabled="!valid" color="primary" type="submits">
              ANLEGEN
            </v-btn>
          </div>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Admin'
import MoneyInputField from '@shared/MoneyInputField'

export default {
   name: 'IncomingEditOrder',
   components: {
      MoneyInputField
   },
   layout: (h, page) => h(Layout, [page]),
   metaInfo () {
      return {
         title: this.title ? this.title : 'Bestellung Bearbeiten',
      }
   },
   props: {
      purchaseItems: {
         type: Array,
         required: true
      },
      purchase: {
         type: Object,
         required: true
      },
      availablePurchaseItems: {
         type: Array,
         required: true
      }
   },
   data () {
      return {
         valid: false,
         toAdd: this.purchaseItems,
         orderNumber: this.purchase.invoice_number,
         data: []
      }
   },
   methods: {
      create () {
         this.$inertia.patch(this.route('purchase.update', this.purchase.id), {
            invoiceNumber: this.orderNumber,
            positions: this.toAdd
         })
      },
      add () {
         this.toAdd.push({
            purchaseItem: null,
            amount: null,
            price: null,
         })
      },
      remove (position) {
         this.toAdd.splice(position, 1)
      },
      updateDeliveryStatus (id, status) {
         if (status === null) {
            status = false
         }
         this.$inertia.patch(this.route('purchase.update_status', [this.purchase.id, id, status]))
      }
   }
}
</script>

<style>

</style>
